import React, { useEffect, useState } from "react";
import { Popover } from "antd";
import IconButtonV2 from "../IconButtonV2";
import { VolumeSlider } from "../../editor/components/VolumeSlider";
import { MasterVolumeContainer } from "./styles";

export function MasterVolumeControl({
  audioPlayerEl,
  size = "md",
  buttonStyle
}) {
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(1);

  // changes the playback volume
  const applyVolume = newVolume => {
    if (audioPlayerEl.current) {
      audioPlayerEl.current.volume = newVolume;
    }
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  const onChange = val => {
    setVolume(val / 100);
  };

  useEffect(() => {
    applyVolume(isMuted ? 0 : volume);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMuted, volume]);

  return (
    <MasterVolumeContainer>
      <Popover
        placement="top"
        getPopupContainer={trigger => trigger}
        content={
          <VolumeSlider
            onChange={onChange}
            onAfterChange={onChange}
            currentVolume={volume}
            vertical
          />
        }
        {...(isMuted && { visible: false })}
      >
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          <IconButtonV2
            type={isMuted ? "volume_muted" : "volume"}
            size={size}
            onClick={toggleMute}
            label={isMuted ? "Unmute" : "Mute"}
            hoverBackground={false}
            style={buttonStyle}
          />
        </span>
      </Popover>
    </MasterVolumeContainer>
  );
}
